import React, { FC, ReactNode, useState } from 'react';
import { CoKitchenPolygons, CoKitchenType } from 'utils/types';
import { CokitchenContext } from './context';
import moment from 'moment';

const CokitchenProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const kitchenForm = {
    name: '',
    address: '',
    customer_service_phone_number: [],
    frontdesk_phone_number: [],
    customer_service_whatsapp: [],
    frontdesk_whatsapp: [],
    cover_images: [],
    cover_videos: [],
    lat: '',
    lng: '',
    cokitchen_status: 'standard',
    event_image: null,
    brand_ids: [],
    cokitchen_explore_ids: [],
    active: false,
    description: '',
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().add(1, 'days').format('YYYY-MM-DD')
  } as unknown as CoKitchenType;
  const [disabled, setDisabled] = useState(false);
  const [kitchenLoading, setKitchenLoading] = useState(false);
  const [newCokitchen, setNewCokitchen] = useState<CoKitchenType | null>(null);
  const [activeKitchen, setActiveKitchen] = useState({} as CoKitchenType);
  const [activePolygon, setActivePolygon] = useState<any>();

  const [createCokitchenForm, setCreateCokitchenForm] = useState(kitchenForm);
  const [editCokitchenForm, setEditCokitchenForm] = useState(kitchenForm);
  const [cokitchenPolygons, setCokitchenPolygons] = useState<CoKitchenPolygons[]>([]);

  return (
    <CokitchenContext.Provider
      value={{
        activeKitchen,
        setActiveKitchen,
        kitchenLoading,
        setKitchenLoading,
        disabled,
        setDisabled,
        createCokitchenForm,
        setCreateCokitchenForm,
        editCokitchenForm,
        setEditCokitchenForm,
        activePolygon,
        setActivePolygon,
        cokitchenPolygons,
        setCokitchenPolygons,
        newCokitchen,
        setNewCokitchen
      }}>
      {children}
    </CokitchenContext.Provider>
  );
};

export default CokitchenProvider;
